module.exports = __webpack_public_path__ + "img/duplicate.464b93a8.svg";